import React from "react";
import DwaAppContext from "../@dwa/DwaAppContext";

const useDwaApp = () => {
    return React.useContext(DwaAppContext);
};

export default useDwaApp;
